import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CCVirt icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CCVirt } from '@sravni/design-system-icons'
 *
 * <CCVirt />
 * ```
 */
var CCVirt = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CCVirt", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.403 12.5v3.44c0 .862-.698 1.56-1.56 1.56H4.796a1.56 1.56 0 0 1-1.559-1.56V4.06c0-.862.699-1.56 1.56-1.56h6.047c.862 0 1.56.698 1.56 1.56v1.773M5.986 15.417h3.667", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M9.347 5.833h7.778c.614 0 1.111.498 1.111 1.111v4.444c0 .614-.497 1.112-1.11 1.112H9.348a1.111 1.111 0 0 1-1.112-1.11V6.943c0-.613.498-1.11 1.111-1.11v0ZM8.236 8.333h10", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CCVirt };
//# sourceMappingURL=CCVirt.js.map
